interface OnboardingBannerProps {
  onDismiss: () => void
}

export function OnboardingBanner({ onDismiss }: OnboardingBannerProps) {
  return (
    <aside className="relative rounded-xl border border-primary/30 bg-primary/5 px-5 py-4 space-y-3">
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors text-sm leading-none"
      >
        ✕
      </button>

      <div className="space-y-2 pr-6">
        <p className="text-sm font-semibold">Not sure what you'd even talk about?</p>
        <p className="text-xs text-muted-foreground">
          Most students have more stories than they think. A 10-minute chat turns your classes,
          clubs and jobs into answers you can use.
        </p>
        <a
          href="/story-intake?from=onboarding"
          className="inline-block rounded-lg bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground transition-opacity hover:opacity-90"
        >
          Find my stories
        </a>
      </div>

      <div className="space-y-1 border-t border-border pt-3">
        <p className="text-xs font-semibold">Or see what your feedback will look like</p>
        <p className="text-xs text-muted-foreground">
          RoleRound scores every answer on the STAR method — see a finished report before you start.
        </p>
      </div>

      {/* Decorative mini score preview */}
      <div className="rounded-lg border border-border bg-background px-3 py-2 flex items-center gap-4 text-xs pointer-events-none select-none opacity-80">
        <span className="font-bold tabular-nums text-emerald-600 dark:text-emerald-400 text-lg leading-none">
          3.7
        </span>
        <div className="flex-1 space-y-1.5">
          {[
            { label: 'Action', pct: 86, color: 'bg-emerald-500' },
            { label: 'Result', pct: 40, color: 'bg-amber-500' },
          ].map(({ label, pct, color }) => (
            <div key={label} className="flex items-center gap-2">
              <span className="w-12 text-muted-foreground">{label}</span>
              <div className="flex-1 h-1.5 rounded-full bg-muted overflow-hidden">
                <div className={`h-full rounded-full ${color}`} style={{ width: `${pct}%` }} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <a
        href="/sample-reports"
        className="inline-flex items-center gap-1 text-xs font-medium text-primary underline underline-offset-2 hover:opacity-80 transition-opacity"
      >
        Browse sample reports →
      </a>
    </aside>
  )
}
